import { render, staticRenderFns } from "./cPdfNota.vue?vue&type=template&id=0b74fc1f"
import script from "./cPdfNota.vue?vue&type=script&lang=js"
export * from "./cPdfNota.vue?vue&type=script&lang=js"
import style0 from "./cPdfNota.vue?vue&type=style&index=0&id=0b74fc1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports